import { h, Component, Prop } from '@stencil/core';

import { isNumber } from '../../../../services/utils';

@Component({
  tag: 'pk-num-stat-item',
  styleUrl: './scss/pk-num-stat-item.scss',
  shadow: true,
})
export class PkNumStatItem {
  // Own Properties
  // ====================

  // Reference to host HTML element
  // ===================================
  //@Element() el: HTMLPkNumStatItemElement;

  // State() variables
  // Inlined decorator, alphabetical order
  // =======================================

  // Public Property API
  // ========================

  /** Set enriched or basic version */
  @Prop() variant: 'primary' | 'secondary' = 'primary';

  /** Set image source */
  @Prop() imgSrc?: string;

  /** Set image alt text */
  @Prop() imgAlt?: string;

  /** Set the value for progress bar (when added, the progress bar will be displayed) */
  @Prop() progressBarValue?: number;

  // Prop lifecycle events
  // =======================

  // Events section
  // Requires JSDocs for public API documentation
  // ==============================================

  // Component lifecycle events
  // Ordered by their natural call order
  // =====================================

  // Called once just after the component fully loaded and the first render() occurs

  // Listeners
  // ==============

  // Public methods API
  // These methods are exposed on the host element.
  // Always use two lines.
  // Public Methods must be async.
  // Requires JSDocs for public API documentation.
  // ===============================================

  // Local methods
  // Internal business logic.
  // These methods cannot be called from the host element.
  // =======================================================

  // render() function
  // Always the last one in the class.
  // ===================================

  render() {
    return (
      <div class={{ 'num-stat-item': true, 'num-stat-item--secondary': this.variant === 'secondary' }} part="base">
        <div class="max-w-full" part="item-left">
          <div class={{ 'flex items-center': this.variant === 'secondary' }} part="data-container">
            <slot name="left-img" />
            <slot name="stat-value" />
            {this.variant === 'primary' && <slot name="stat-value-secondary" />}
          </div>
          <slot name="stat-label" />
          <slot name="stat-second-label" />
          {isNumber(this.progressBarValue) && (
            <div class="mt-xs" part="progress-container">
              <pk-progress-indicator
                percentages={this.progressBarValue}
                trackAreaColor="ui-02"
                stroke={3}
                part="progress-indicator"
              ></pk-progress-indicator>
            </div>
          )}
        </div>
        {this.variant === 'primary' && this.imgSrc && (
          <div class="max-w-full" part="item-right">
            <pk-image src={this.imgSrc} alt={this.imgAlt} width={70} part="image" />
          </div>
        )}
      </div>
    );
  }
}
